import ExternalLink from "../../components/ExternalLink"
import { checkValidKey } from "../../util/functions"
import { APIs, Scenario } from "./data"

export const validateScenario = (scenario: Scenario): Scenario => {
    const result = scenario
    
    const api = APIs[scenario.api]

    // Make sure we have a valid package manager and framework choice
    scenario.packageManager = checkValidKey(api.packageManagers, scenario.packageManager) ?? ''
    scenario.framework = checkValidKey(api.frameworks, scenario.framework) ?? ''

    // Force clusterManager=FALSE when not using Compute Server
    if(!['cs', 'fcs', 'wlscs'].includes(scenario.license)) {
        scenario.clusterManager = false
    }

    // Force containerServer=TRUE/FALSE depending on the license type
    if(scenario.license == 'cs') {
        result.containerServer = false
    }

    // Force containerClient=TRUE/FALSE depending on the license type
    if(!['ic', 'cs', 'fcs', 'wlscs', 'fu', 'wlssu', 'wlsuu'].includes(scenario.license)) {
        result.containerClient = false
    }

    // Force containerOrchestration=FALSE when not applicable
    if(!['wlssu', 'wlsuu', 'wlscs'].includes(scenario.license) && !result.containerClient && !result.containerServer) {
        result.containerOrchestration = false
    }    
    
    return result
}

export const NotSupportedLinks = () => {
    return <>Have a look at our generic <ExternalLink href="https://support.gurobi.com/hc/en-us/articles/14799677517585-Getting-Started-with-Gurobi-Optimizer">Getting Started</ExternalLink> guides and official <ExternalLink href="https://www.gurobi.com/documentation/">documentation</ExternalLink> for more information.</>;
}

export const isSupported = (scenario: Scenario): string | undefined => {
    if(['isv'].includes(scenario.license)) {
        return 'ISV keys are not supported yet.'
    }
    if(!['python', 'csharp'].includes(scenario.api)) {
        return 'Only the Python and C# API are currently supported.'
    }
    if(scenario.containerOrchestration) {
        return 'Container orchestration is not supported yet.'
    }
    return undefined
}

/**
 * Update a scenario by changing a single property
 * @param scenario Current scenario
 * @param key Scenario property to be updated
 * @param value New value for the scenario property
 * @returns Updated, validated version of the scenario
 */
export const updateScenario = (scenario: Scenario, key: keyof Scenario, value: any) => {
    const csLicenses = ['cs', 'wlscs', 'fcs']
    const next = { ...scenario, [key]: value }
    if(key=='license' && !csLicenses.includes(scenario.license) && csLicenses.includes(value)) {
        next.clusterManager=true
    }
    const updatedScenario = validateScenario(next)    
    return updatedScenario
}

